import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Button,
  Spinner,
  Badge,
} from "reactstrap"
import toast from "toastr"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { get_erp_clients, sync_all_erp_clients } from "helpers/backend_helper"
import ErpClientsTable from "./ErpClientsTable"

const isOk = res => res?.statusCode === 200 || res?.StatusCode === 200

const Index = () => {
  document.title = "ERP Clients | TenderSoftware - Flexi TracBoard"

  const [clients, setClients] = useState([])
  const [loading, setLoading] = useState(false)
  const [syncLoading, setSyncLoading] = useState(false)

  const loadClients = useCallback(async () => {
    setLoading(true)
    try {
      const res = await get_erp_clients()
      setClients(res?.data || res?.Data || [])
    } catch (error) {
      toast.error(error?.message || "Failed to load ERP clients")
      setClients([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadClients()
  }, [loadClients])

  const handleSyncAll = async () => {
    setSyncLoading(true)
    try {
      const res = await sync_all_erp_clients()
      if (isOk(res)) {
        toast.success(res?.message || res?.Message || "Clients synced from ERP")
        loadClients()
      } else {
        toast.error(res?.message || res?.Message || "Failed to sync clients")
      }
    } catch (error) {
      toast.error(error?.message || "Failed to sync clients from ERP")
    } finally {
      setSyncLoading(false)
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Customer Name",
        accessor: "customer_name",
        Cell: ({ row }) => row.original.customer_name || row.original.name,
      },
      {
        Header: "ERP Id",
        accessor: "name",
      },
      {
        Header: "Group",
        accessor: "customer_group",
        Cell: ({ value }) => value || "-",
      },
      {
        Header: "Territory",
        accessor: "territory",
        Cell: ({ value }) => value || "-",
      },
      {
        Header: "Status",
        accessor: "disabled",
        Cell: ({ value }) =>
          value === 0 || value === "0" ? (
            <Badge color="success">Active</Badge>
          ) : (
            <Badge color="secondary">Disabled</Badge>
          ),
      },
      {
        Header: "Action",
        disableSortBy: true,
        Cell: ({ row }) => (
          <Link
            to={`/erp-client/${encodeURIComponent(row.original.name)}`}
            className="btn btn-sm btn-outline-primary"
          >
            View
          </Link>
        ),
      },
    ],
    []
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title={"ERP Clients"} breadcrumbItem={"ERP Clients"} />
        <Row>
          <Col xs="12">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">ERP CRM Customers</h5>
                <Button
                  color="primary"
                  onClick={handleSyncAll}
                  disabled={syncLoading}
                >
                  {syncLoading ? (
                    <>
                      <Spinner size="sm" className="me-1" /> Syncing...
                    </>
                  ) : (
                    <>
                      <i className="mdi mdi-sync me-1" /> Sync from ERP
                    </>
                  )}
                </Button>
              </CardHeader>
              <CardBody>
                {loading ? (
                  <div className="text-center p-5">
                    <Spinner /> Loading clients...
                  </div>
                ) : (
                  <ErpClientsTable columns={columns} data={clients} customPageSize={15} />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Index
